exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.dropdown-menu{width:100%!important;min-width:auto!important}.bootstrap-select>.dropdown-toggle{border:1px solid #ced4da}", ""]);

// exports
